import { createContext, useContext } from 'react';

export const SpinnerContext = createContext<{
  showSpinner: () => void;
  hideSpinner: () => void;
}>({
  showSpinner: () => {},
  hideSpinner: () => {},
});

export const useSpinner = () => useContext(SpinnerContext);
